class Broadcasts {
  async get(args) {
    const results = await this.search(args);

    return results[0] ? results[0] : null;
  }

  async search(args) {
    try {
      const results = await $.ajax({
        url: window.bvm.ajax,
        method: 'POST',
        data: {
          action: 'bvm_repositories_broadcasts_search',
          ...args,
        },
      });

      if (results.success && results.data.length) {
        return results.data;
      }
    } catch (error) {
      console.error(error);
    }

    return [];
  }
}

export default Broadcasts;
